const url = require('url');
const get = require('lodash/get');

const PRISMIC_ASSET_HOST = 'wonderbly.cdn.prismic.io';
const IMGIX_PRISMIC_HOST = 'wbly-prismic-v${i}.imgix.net';

let imgixHostIndex = -1;
const maxImgixHostIndex = 4;
/**
 * load images faster by sharding the hosts. IMGIX let you setup for the same
 * source multiple subdomains. Setting up 4 means we can overcome the browser's
 * limitation of 6 open connections per host.
 * @returns {string}
 */
const getImgixHost = () => {
  if (++imgixHostIndex === maxImgixHostIndex) {
    imgixHostIndex = 0;
  }
  return IMGIX_PRISMIC_HOST.replace('${i}', imgixHostIndex);
};

const resetImgixHostIndex = () => {
  imgixHostIndex = -1;
};

// Checking if the URL is Prismic Url or not (wonderbly.cdn.prismic.io);
const isPrismicUrl = imageUrl => {
  if (!imageUrl) {
    return false;
  }
  return imageUrl.startsWith(`https://${PRISMIC_ASSET_HOST}`);
};

const getPrismicImageName = imageUrl => {
  if (!imageUrl) {
    return '';
  }
  return url.parse(imageUrl).pathname;
};

//const defaultQuality = 45;


// Takes prismic image url and returns optimised image url:
const optimiseImage = (imageUrl, query={ auto: 'format,compress' }) => {

  if (!isPrismicUrl(imageUrl)) {
    return imageUrl;
  }

  return url.format({
    protocol: 'https:',
    host: getImgixHost(),
    pathname: getPrismicImageName(imageUrl),
    query,
  });
};

/**
 * @link https://blog.imgix.com/2016/03/30/dpr-quality.html
 * @link https://docs.imgix.com/tutorials/responsive-images-client-hints
 */


// Takes image object and returns optimized prismic image url with dpr injected
const prismicImage = (image, config = {}) => {
  config = {
    width: get(image, 'dimensions.width'),
    ...config,
    // dpr should be injected, not derived
    // it doesn't make any sense when SSR.
    // dpr: config.dpr || getDevicePixelRatio(),
  };

  // fail safe to avoid division by zero
  if (config.dpr === 0) {
    config.dpr = 1;
  }

  const query = {
    auto: 'format,compress',
    dpr: config.dpr,
    w: config.width || null,
    h: config.height || null,
    fit: config.fit || null,
    crop: config.crop || null,
    'gif-q': 60 // gif compression - higher is more compression
  };

  return optimiseImage(image.url, query);
};

const dprList = [{ dpr: 1 }, { dpr: 2 }];

// Takes image object and returns an object with src and srcSet parameters
const prismicDPRSrcSet = image => {
  const srcSet = dprList.map(config => prismicImage(image, config) + (config.dpr > 1 ? ` ${config.dpr}x` : ''));

  return {
    src: srcSet[0],
    srcSet: srcSet.join(', '),
  };
};

module.exports = {
  resetImgixHostIndex,
  prismicImage,
  isPrismicUrl,
  optimiseImage,
  prismicDPRSrcSet,
};



// WEBPACK FOOTER //
// ./src/common/utils/prismic-image.js